"use strict";

import jQuery from 'jquery';

/**
 * @enum {string}
 */
gc.gis.control.GCMapProjectionSwitcherEvent = {
	UPDATED: 'projection:update'
};

/**
 * Control zum Ändern der Kartenprojektion.
 *
 * @class
 * @extends gc.gis.control.GCAbstractMapControl
 * @memberof gc.gis.control
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen (siehe {@link gc.gis.control.GCAbstractMapControl})
 */
gc.gis.control.GCMapProjectionSwitcher = function( options )
{
	gc.gis.control.GCAbstractMapControl.call( this, options );

	this._crs_list = this._map.getAvailableProjections();
};
gc.gis.control.GCMapProjectionSwitcher.prototype = Object.create( gc.gis.control.GCAbstractMapControl.prototype );

/**
 * @inheritdoc
 */
gc.gis.control.GCMapProjectionSwitcher.prototype.init = function()
{
	var self = this;

	this._render();
	this.updateCRS();

	this._map.on( gc.gis.map.GCMapEvent.PROJECTION_CHANGED, this, function(evt) {
		self.updateCRS();
	});
};

/**
 * Rendert das Control.
 *
 * @protected
 * @return {jQuery} Container-Element
 */
gc.gis.control.GCMapProjectionSwitcher.prototype._render = function()
{
	var self = this;

	// Root-Element erstellen oder leeren
	if( !this._element )
	{
		this._element = jQuery('<div>', {
			'class': 'gc-map-control gc-map-control-projection-switcher gc-hidden-xs gc-hidden-sm-expanded' +(this._className ? ' '+this._className : '')
		});
		if( this._id )
		{
			this._element.attr('id', this._id.replace('#', '') );
		}
	}
	else
	{
		this._element.children().remove();
	}

	// Formularelemente erstellen
	var element_label_text = jQuery('<span>', {
		'class': 'control-label gc-hidden-xs gc-hidden-sm gc-hidden-md-expanded',
		text: 'Projektion:'
	});
	this.__element_label = jQuery('<label>', {
		'class': 'form-group',
		text:' '}
	);

	this.__element_select = jQuery('<select>', {
		title: 'Projektion ändern',
		'class': 'form-control gc-control-select gc-crs-select gc-md-max-width-12em gc-sm-max-width-10em'
	});
	gc.gis.iface.ui.tooltip(this.__element_select, {
		placement: 'auto top'
	});
	this.__element_select.on('change', function( evt ) {
		self.setCRS( this.value );
	});

	this.__element_label.prepend( element_label_text )
	                    .append( this.__element_select );
	this._element.append( this.__element_label );

	// Liste befüllen
	for( var i=0; i<this._crs_list.length; i++ )
	{
		var element_option = jQuery('<option>', {
			text:  this._crs_list[i].label,
			value: this._crs_list[i].code
		});
		this.__element_select.append( element_option );
	}

	// Initiales CRS setzen
	this.__element_select.val( self._map.getProjection() );

	return this._element;
};

/**
 * Setzt die Projektion der zugeordneten Karteninstanz.
 *
 * @public
 * @param {string} value Kartenprojektion
 */
gc.gis.control.GCMapProjectionSwitcher.prototype.setCRS = function( value )
{
	try
	{
		this._map.setProjection( value );
	}
	catch( err )
	{
		gc.gis.iface.log.error( this, err );
	}

	this.updateCRS();
};

/**
 * Aktualisiert die Kartenprojektion des Controls.
 *
 * @public
 * @see gc.gis.map.GCMapView#getProjection
 */
gc.gis.control.GCMapProjectionSwitcher.prototype.updateCRS = function()
{
	var crs = this._map.getProjection();
	this.__element_select.val( crs );
};

